export default "__VITE_ASSET__73ee9dee__"